import { ConstantItems } from '@constants/shared'

export class HealthService {
  static $inject = ["$http", "config"];

  constructor(private $http: angular.IHttpService, private config: ConstantItems) { }

  getHealthConfig() {
    return this.$http.get(`${this.config.healthUrl}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/health/health.service.ts